const INSTANA_KEY = import.meta.env.PUBLIC_ENV__INSTANA_KEY

function loadInstanaScript() {
  return new Promise<void>((resolve, reject) => {
    if (document.getElementById('instana-eum-script')) {
      resolve()
      return
    }

    if (!document.getElementById('instana-eum-inline')) {
      const scriptiInline = document.createElement('script')
      scriptiInline.id = 'instana-eum-inline'
      scriptiInline.type = 'text/javascript'
      scriptiInline.text = `(function(n,e,i,u,t){
                    if(!n[e]){n[e]=i;t=n[i]=function(){
                    t.q.push(arguments)
                    };
                    t.q=[];
                    t.v=2;
                    t.l=1*new Date;
                    n[u]=function(){n[i].apply(null,arguments)}}})
                    (window,"InstanaEumObject","ineum","sofaEum");
                    ineum('reportingUrl', 'https://eum-green-saas.instana.io');
                    ineum('key', '${INSTANA_KEY}');
                    ineum('trackSessions');
                    ineum('autoPageDetection', { titleAsPageName: true });`

      document.head.appendChild(scriptiInline)
    }

    const script = document.createElement('script')
    script.id = 'instana-eum-script'
    script.src = 'https://eum.instana.io/1.8.1/eum.min.js'
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Échec chargement Instana'))

    document.head.appendChild(script)
  })
}

export default {
  install() {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return
    }
    loadInstanaScript()
  },
}
